import { $ } from '../utils/Utils';

const project = (() => {
  const categoryFilterSelector = [...$('.js-categoryFilter li input')];

  function loopOverElements(func, selector = '.js-projects li') {
    Array.prototype.filter.call(document.querySelectorAll(selector), func);
  }

  const init = () => {
    categoryFilterSelector.forEach(filter => filter.addEventListener('change', () => {
      const filterCategory = filter.parentElement.parentElement.dataset.category;

      // eslint-disable-next-line no-restricted-globals
      if (isNaN(filterCategory)) {
        loopOverElements((e) => { e.classList.add('-hide'); });
        loopOverElements((e) => { e.classList.remove('-hide'); }, `.js-projects li[data-category="${filterCategory}"]`);
      } else {
        loopOverElements((e) => { e.classList.remove('-hide'); });
      }
    }));
  };

  return {
    init,
  };
})();

export default project.init();
